import { PrototypeBannerComponent } from '@geogirafe/lib-geoportal/components';
import { MapbsConfig } from '../../bs/config/mapbsconfig';

export default class MapbsPrototypeBannerComponent extends PrototypeBannerComponent {
  override templateUrl = './template.html';
  override styleUrls = [
    './style.css',
    '../../../node_modules/@geogirafe/lib-geoportal/components/prototypebanner/style.css'
  ];

  public get mapbsConfig() {
    //Import the mapbs config file
    return this.context.configManager.Config.extendedConfig as unknown as MapbsConfig;
  }

  get bannerText(): string {
    const bannerName = this.mapbsConfig.bannerName; //Load the name

    //If it does not exist return Prototype
    return bannerName ?? 'Prototype';
  }
}
